const STATUS = {
    OPEN: { bg: "bg-yellow-500/10", fg: "text-yellow-400", bd: "border-yellow-500/30", label: "Open" },
    IN_PROGRESS: { bg: "bg-sky-500/10", fg: "text-sky-400", bd: "border-sky-500/30", label: "In progress" },
    WAITING_CLIENT: { bg: "bg-violet-500/10", fg: "text-violet-400", bd: "border-violet-500/30", label: "Waiting client" },
    RESOLVED: { bg: "bg-emerald-500/10", fg: "text-emerald-400", bd: "border-emerald-500/30", label: "Resolved" },
    CLOSED: { bg: "bg-zinc-500/10", fg: "text-zinc-400", bd: "border-zinc-500/30", label: "Closed" },
    ESCALATED: { bg: "bg-red-500/10", fg: "text-red-400", bd: "border-red-500/30", label: "Escalated" },
    REOPENED: { bg: "bg-orange-500/10", fg: "text-orange-400", bd: "border-orange-500/30", label: "Reopened" },
};

export default function StatusBadge({ value }) {
    const s = STATUS[value] || STATUS.OPEN;
    return (
        <span
            data-testid={`status-badge-${value}`}
            className={`inline-flex items-center px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider rounded-sm border ${s.bg} ${s.fg} ${s.bd}`}
        >
            {s.label}
        </span>
    );
}
